export default __webpack_public_path__ + "static/media/icon-self-assessment.6604fc26.svg";